
import Vue, { PropType } from "vue";
import { Website } from "@/models";

import BaseInputForm from "@/components/BaseInputForm.vue";
import BaseSelectorForm, { Option } from "@/components/BaseSelectorForm.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";

export type DataType = {
  name: string;
  usePasscodeText: string;
  passcode: string;
  useTenantIdPassText: string;
  memo: string;
  usePasscodeOptions: Array<Option>;
  useTenantIdPassOptions: Array<Option>;
};

export default Vue.extend({
  name: "WebsiteEditor",

  components: {
    BaseInputForm,
    BaseSelectorForm,
    BaseSubmitButton,
    BaseCancelButton,
  },

  props: {
    website: Object as PropType<Website>,
  },

  data(): DataType {
    return {
      name: "",
      usePasscodeText: "",
      passcode: "",
      useTenantIdPassText: "",
      memo: "",

      usePasscodeOptions: [
        {
          name: "使用しない",
          value: "false",
        },
        {
          name: "使用する",
          value: "true",
        },
      ],

      useTenantIdPassOptions: [
        {
          name: "使用しない",
          value: "false",
        },
        {
          name: "使用する",
          value: "true",
        },
      ],
    };
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },

    isEdited(): boolean {
      return (
        this.website.displayName !== this.name ||
        !!this.website.passcode !== this.usePasscode ||
        this.website.passcode !== this.passcode ||
        !!this.website.useTenantIdPass !== this.useTenantIdPass ||
        this.website.memo !== this.memo
      );
    },

    canSubmit(): boolean {
      return (
        !!this.name &&
        !!this.usePasscodeText &&
        ((!!this.usePasscode && !!this.passcode) || !this.usePasscode) &&
        !!this.useTenantIdPassText &&
        (!this.website || this.isEdited)
      );
    },

    usePasscode(): boolean {
      return this.usePasscodeText === "true";
    },

    useTenantIdPass(): boolean {
      return this.useTenantIdPassText === "true";
    },
  },

  watch: {
    website: function(n: Website) {
      this.name = n.displayName || "";
      if (n.passcode !== undefined) {
        this.usePasscodeText = n.passcode ? "true" : "false";
      }
      this.passcode = n.passcode || "";
      if (n.useTenantIdPass !== undefined) {
        this.useTenantIdPassText = n.useTenantIdPass ? "true" : "false";
      }
      this.memo = n.memo || "";
    },
  },

  methods: {
    saveWebsite(): void {
      if (!this.canSubmit) {
        return;
      }

      this.$emit(
        "save-website",
        new Website({
          displayName: this.name,
          passcode: this.usePasscode ? this.passcode : "",
          useTenantIdPass: this.useTenantIdPass,
          memo: this.memo,
        }),
      );
    },
  },
});
